import React from 'react';
import Notices from '../Admin/Notices';
// Teachers reuse the same Notices component — they can post and view notices
export default Notices;
